// TODO: SECURITY — VULN-01: These API keys should NOT be in client-side code.
// Move them behind a backend proxy or Azure API Management gateway so the
// client never possesses service-level keys. Rotate all keys after migration.
// As an interim step, keys are read from VITE_ env vars instead of being
// hardcoded in source. This keeps them out of version control but they are
// still visible in the browser bundle.

export const Endpoints = {
  /** Admin base URL — reads from VITE_API_BASE_URL in .env */
  AdminBaseURl: `${import.meta.env.VITE_API_BASE_URL}/`,

  ConfigAPI: `app-config?code=${import.meta.env.VITE_API_KEY_CONFIG ?? ''}`,
  Login: `user-send-otp?code=${import.meta.env.VITE_API_KEY_SEND_OTP ?? ''}`,
  VerifyOtp: `verify-otp?code=${import.meta.env.VITE_API_KEY_VERIFY_OTP ?? ''}`,
  SignUpAPI: `user-sign-up?code=${import.meta.env.VITE_API_KEY_USER_SIGNUP ?? ''}`,
  plantsAPI: `plants?code=${import.meta.env.VITE_API_KEY_PLANTS_LIST ?? ''}`,

  RefreshTokenAPI: 'refresh-token?code=',
  CarrierAPI: `carrier-list?code=${import.meta.env.VITE_API_KEY_CARRIER ?? ''}`,
  UpdateProfile: 'users?code=',
  NotificationList: 'list-notifications?code=',
  UserLogs: 'user-logs?code=',
  UserLogsConnectivity: 'user-logs-connectivity?code=',
  Manhattan: 'manhattan?code=',
  SignalRNegotiateAPI: 'negotiate?code=',
  Suggestions: 'suggestions?code=',

  /** Build middleware (Manhattan) URL with function code and action */
  buildMiddlewareUrl: (functionCode: string, action: string): string =>
    `manhattan?code=${functionCode}&action=${action}`,
} as const;

// ─────────────────────────────────────────────────────────────────
// YMS API Configuration - Matching Xamarin exactly
// ─────────────────────────────────────────────────────────────────

export const YMS_API_CONFIG = {
  adminBaseUrl: Endpoints.AdminBaseURl,
  timeout: 30000,
  retryAttempts: 3,
  retryDelay: 1000,
  Manhattan: 'manhattan?code={0}&action={1}',
  MAAccessTokenAPI: 'ACCESS_TOKEN_SERVICE/1.0/api/authentication/access_token',
  MAGetTaskListAPI: 'NBL_YMS_GET_TASK_DTLS_MA/1.0/getTaskDetails',
  MAGetTrailersAPI: 'NBL_YMS_GET_TRAILERS/1.0/getTrailerDetails',
  MAGetLocationsAPI: 'NBL_YMS_GET_LOCATION/1.0/getLocationDetails',

  // Create Audit task
  MAGetLocationsListAPI: 'NBL_YMS_GET_LOCATI_LIST/1.0/getLocationList',
  MAUpdateTaskAPI: 'NBL_YMS_UPDAT_TASK_DTLS_MA/1.0/updateTask',
  MAGetTrailerListAPI: 'NBL_YMS_GET_TRAILE_LIST/1.0/getTrailerList',
  MACreateMoveTasksAPI: 'NBL_YMS_CREATE_MOVE_TASK/1.0/updateTask',
  MACreateAuditTasksAPI: 'NBL_YMS_CREATE_AUDIT_TASK/1.0/updateTask',

  // Yard Capacity Utilization — Matches Xamarin Endpoints.MAYardCapacityUtilizationAPI
  MAYardCapacityUtilizationAPI: 'NBL_YMS_GET_YRD_CAP_UTILI/1.0/getCapacityUtilization',

  // Displacement Summary — Matches Xamarin Endpoints.displacedSummaryEndpointAPI
  MAGetDisplacedTrailersAPI: 'NBL_YMS_GET_DISPLA_TRAILE/1.0/getDisplacedTrailers',

  // Update Red Tag (Mark As Damaged) — Matches Xamarin Endpoints.MAUpdateRedTagTrailer
  MAUpdateRedTagTrailerAPI: 'NBL_YMS_UPDATE_TRAILE_V2/1.0/updateTrailers',

  MASummaryAPI: 'NBL_YMS_GET_TASK_BY_USER_AND_DAT/1.0/',
  // Move Task endpoin'ts
  MoveTrailerList: 'move-trailer-list?code=',
  MoveLocationList: 'move-location-list?code=',
  CreateMoveTask: 'create-move-task?code=',
} as const;
